import { render, staticRenderFns } from "./HelpService.vue?vue&type=template&id=018f0bb4&"
import script from "./HelpService.vue?vue&type=script&lang=js&"
export * from "./HelpService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports